export const RESET_STATE_LISTUSERS = 'RESET_STATE_LISTUSERS'
export const LOADING_LISTUSERS = 'LOADING_LISTUSERS'
export const GET_LISTUSERS = 'GET_LISTUSERS'
export const GET_ERROR_LISTUSERS = 'GET_ERROR_LISTUSERS'
export const LOADING_CREATEUSER = 'LOADING_CREATEUSER'
export const POST_CREATEUSER = 'POST_CREATEUSER'
export const POST_ERROR_CREATEUSER = 'POST_ERROR_CREATEUSER'
export const LOADING_LISTROLES = 'LOADING_LISTROLES'
export const GET_LISTROLES = 'GET_LISTROLES'
export const GET_ERROR_LISTROLES = 'GET_ERROR_LISTROLES'
export const LOADING_USERKEYCLOAKINFO = 'LOADING_USERKEYCLOAKINFO'
export const GET_USERKEYCLOAKINFO = 'GET_USERKEYCLOAKINFO'
export const GET_ERROR_USERKEYCLOAKINFO = 'GET_ERROR_USERKEYCLOAKINFO'
export const LOADING_ASSIGNROLES = 'LOADING_ASSIGNROLES'
export const POST_ASSIGNROLES = 'POST_ASSIGNROLES'
export const POST_ERROR_ASSIGNROLES = 'POST_ERROR_ASSIGNROLES'
export const LOADING_UPDATEPASSWORD = 'LOADING_UPDATEPASSWORD'
export const POST_UPDATEPASSWORD = 'POST_UPDATEPASSWORD'
export const POST_ERROR_UPDATEPASSWORD = 'POST_ERROR_UPDATEPASSWORD'
export const POST_UPDATE_USER = 'POST_UPDATE_USER'
export const POST_ERROR_UPDATE_USER = 'POST_ERROR_UPDATE_USER'
export const LOADING_UPDATE_USER = 'LOADING_UPDATE_USER'
export const LOADING_ASSIGNGRUPOS = 'LOADING_ASSIGNGRUPOS'
export const POST_ASSIGNGRUPOS = 'POST_ASSIGNGRUPOS'
export const POST_ERROR_ASSIGNGRUPOS = 'POST_ERROR_ASSIGNGRUPOS'
export const LOADING_LISTGROUPS = 'LOADING_LISTGROUPS'
export const GET_LISTGROUPS = 'GET_LISTGROUPS'
export const GET_ERROR_LISTGROUPS = 'GET_ERROR_LISTGROUPS'
export const LOADING_UPDATEPASSWORD_ADMIN = 'LOADING_UPDATEPASSWORD_ADMIN'
export const POST_UPDATEPASSWORD_ADMIN = 'POST_UPDATEPASSWORD_ADMIN'
export const POST_ERROR_UPDATEPASSWORD_ADMIN = 'POST_ERROR_UPDATEPASSWORD_ADMIN'
export const RESET_PASSWORD_ADMIN = 'RESET_PASSWORD_ADMIN'
export const LOADING_SYNCHRONIZED_KEYCLOAK = 'LOADING_SYNCHRONIZED_KEYCLOAK'
export const POST_SYNCHRONIZED_KEYCLOAK = 'POST_SYNCHRONIZED_KEYCLOAK'
export const POST_ERROR_SYNCHRONIZED_KEYCLOAK = 'POST_ERROR_SYNCHRONIZED_KEYCLOAK'
export const GET_UNSYNC_USERS_SUCCESS = 'GET_UNSYNC_USERS_SUCCESS'
export const GET_UNSYNC_USERS_REQUEST = 'GET_UNSYNC_USERS_REQUEST'
export const GET_UNSYNC_USERS_ERROR = 'GET_UNSYNC_USERS_ERROR'
export const ACTIVATE_USER_REQUEST = 'ACTIVATE_USER_REQUEST'
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS'
export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR'
export const ACTIVATE_MULTIPLE_USERS_REQUEST = 'ACTIVATE_MULTIPLE_USERS_REQUEST'
export const ACTIVATE_MULTIPLE_USERS_SUCCESS = 'ACTIVATE_MULTIPLE_USERS_SUCCESS'
export const ACTIVATE_MULTIPLE_USERS_ERROR = 'ACTIVATE_MULTIPLE_USERS_ERROR'